<template>
	<div class="page" :style="{height:fixedHeight+'px'}">
		<div class="searchbox" style="padding: 0 20px;">
			<div style="display: flex;align-items: center;"> 
				<div style="margin-right: 20px;">
					<el-input style="width:160px;margin-right: 10px;" placeholder="请输入名称" v-model="params.keyword"
						@keyup.enter.native="clickSearch" clearable size="small"></el-input>
					<el-button @click="clickSearch" icon="el-icon-search" type="warning" size="small">搜索</el-button>
				</div>
				<div style="display: flex;align-items: center;margin-right: 20px;">
					<div style="margin-right: 10px;">种类</div>
					<el-select v-model="params.pets_type" placeholder="请选择" clearable @change="clickSearch" size="small" style="width: 100px;">
						<el-option label="猫" value="1">
						</el-option>
						<el-option label="狗" value="2">
						</el-option>
					</el-select>
				</div>

				<div style="display: flex;align-items: center;margin-right: 20px;">
					<div style="margin-right: 10px;">状态</div>
					<el-select style="width: 100px;" v-model="params.status" placeholder="请选择" clearable
						@change="clickSearch" size="small">
						<el-option label="全部" :value="-1">
						</el-option>
						<el-option label="求购中" :value="1">
						</el-option>
						<el-option label="已处理" :value="2">
						</el-option>
						<el-option label="已完成" :value="3">
						</el-option>
					</el-select>
				</div>

			</div>
		</div>
		<div class="con" :style="{height:fixedHeight-82+'px'}">
			<div class="table">
				<el-table :data="lookingForData" style="width: 100%">
					<el-table-column label="顾客" prop="user_info.user_name">
					</el-table-column>
					<el-table-column prop="user_info.user_mobile" label="手机号">
					</el-table-column>
					<el-table-column label="求购时间">
						<template slot-scope="scope">
							<span>{{$public.FTime(scope.row.create_time,'YYYY-MM-DD')}}</span>
						</template>
					</el-table-column>
					<el-table-column prop="pets_type.project_name" label="求购种类">
					</el-table-column>
					<el-table-column prop="pets_sex" label="性别">
					</el-table-column>
					<el-table-column prop="pets_breed" label="品种">
					</el-table-column>
					<el-table-column label="价格区间">
						<template slot-scope="scope">
							<span>{{scope.row.min_price}}</span>
							-
							<span>{{scope.row.max_price}}</span>
						</template>
					</el-table-column>
					<el-table-column prop="pets_color" label="毛色">
					</el-table-column>

					<el-table-column prop="eprom_no" label="参考图片" width="200">
						<template slot-scope="scope">
							<el-image v-for="(item,index) in scope.row.pets_pics" :key='index'
								style="width: 30px; height: 30px;margin-left: 5px;" :src="item" :preview-src-list="scope.row.pets_pics">
							</el-image>
						
						</template>
					</el-table-column>
					<el-table-column prop="explain" label="其他说明" width="110px">
						<template slot-scope="scope">
							<span class="explain">{{scope.row.explain}}</span>
							<el-popover placement="right" width="200" trigger="click">
								{{scope.row.explain}}
								<i class="el-icon-view" slot="reference"></i>
							</el-popover>
						</template>
					</el-table-column>

					<el-table-column label="状态">
						<template slot-scope="scope">
							<span v-if="scope.row.status==1">求购中</span>
							<span v-if="scope.row.status==2">已处理</span>
							<span v-if="scope.row.status==3">已完成</span>
						</template>
					</el-table-column>
					<el-table-column label="操作" width="100px">
						<template slot-scope="scope">
							<el-button type="text" v-if="scope.row.status==1" size="small"
								@click='dealwith(scope.row._id)'>已处理
							</el-button>
							<el-button v-if="scope.row.status!=3" type="text" size="small"
								@click='complete(scope.row._id)'>完成</el-button>
						</template>
					</el-table-column>
				</el-table>
				<page :total="total" :page="params.page_index" :pageSize='params.page_size' @change="changePage" style="padding: 10px 0;"></page>
			</div>
		</div>

	</div>
</template>

<script>
	import page from "../../components/page.vue"

	import {
		getPetLookingFor,
		statusReplied,
		statusSuccess
	} from '../../api/program.js'
	export default {
		components: {
			page
		},
		data() {
			return {
				fixedHeight:'',
				params: {
					page_index: 1,
					page_size: 10,
					keyword: '',
					pets_type: '',
					status: -1,
				},
				total: 0,
				categoryData: [],
				isHighlight: true,
				lookingForData: [],
				petType: [],
				dialogGiftbag: false,
			}
		},
		methods: {
			getPetLookingFor() {
				getPetLookingFor(this.params).then(res => {
					if (res.code == 0) {
						this.lookingForData = res.data.data;
						this.total = res.data.count;
					}
				})
			},
			changePage(val) {
				this.params.pageIndex = val;
				this.getPetLookingFor();
			},
			clickSearch() {
				this.params.page_index = 1;
				this.getPetLookingFor();
			},
			handleNodeClick(data) {
				this.params.breedid = data.id;
				this.getPetLookingFor();
			},

			dealwith(id) {
				statusReplied({
					id
				}).then(res => {
					if (res.code == 0) {
						this.$message({
							type: 'success',
							message: '处理成功'
						});
						this.getPetLookingFor();
					}
				})

			},
			complete(id) {
				statusSuccess({
					id
				}).then(res => {
					if (res.code == 0) {
						this.$message({
							type: 'success',
							message: '处理成功'
						});
						this.getPetLookingFor();
					}
				})
			}
		},
		created() {
			this.fixedHeight = document.documentElement.clientHeight - 86;
			this.getPetLookingFor();
			// this.getProductType();
			// this.getPetType();
		}
	}
</script>

<style lang="scss" scoped="scoped">
	.searchbox {
		font-size: 14px;
		background: #fff;
		height: 72px;
		display: flex;
		align-items: center;
		padding:0 20px;
	}

	.con {
		display: flex;
		margin-top: 10px;

		.table {
			flex: 1;
			background-color: #fff;
		}

		.explain {
			width: 100px;
			overflow: hidden;
			text-overflow: ellipsis;
			white-space: nowrap;
		}
	}
</style>
